export default "__VITE_ASSET__fqxmKfUd__"